<div class="repeated-vouchers-modal">
  <form [formGroup]="form">
    <div class="repeated-vouchers-modal__date-row">
      <div class="repeated-vouchers-modal__date-input">
        <i class="fas fa-calendar-alt repeated-vouchers-modal__date-icon"></i>
        <input
          bsDaterangepicker
          [bsConfig]="bsConfig"
          type="text"
          class="form-control repeated-vouchers-modal__date-control"
          formControlName="dateRange"
          placeholder="Selecciona el rango"
        />
      </div>

      <button
        type="button"
        class="repeated-vouchers-modal__btn-primary"
        [disabled]="isLoading"
        (click)="search()"
      >
        Consultar
      </button>
    </div>
  </form>

  @if (hasSearched && !isLoading) {
    <div class="repeated-vouchers-modal__summary-grid">
      <div class="repeated-vouchers-modal__kpi-card">
        <div class="repeated-vouchers-modal__kpi-label">Total detectados</div>
        <div class="repeated-vouchers-modal__kpi-value">{{ totalResults }}</div>
      </div>

      <div class="repeated-vouchers-modal__kpi-card">
        <div class="repeated-vouchers-modal__kpi-label">Monto en riesgo</div>
        <div class="repeated-vouchers-modal__kpi-value danger">
          $ {{ totalRiskAmount | number: '1.0-0' }}
        </div>
      </div>
    </div>
  }

  @if (errorMessage) {
    <div class="repeated-vouchers-modal__error">
      {{ errorMessage }}
    </div>
  }

  @if (!hasSearched && !isLoading && !errorMessage) {
    <div class="repeated-vouchers-modal__placeholder">
      Selecciona un rango para verificar comprobantes repetidos.
    </div>
  }

  @if (isLoading) {
    <div class="repeated-vouchers-modal__loading">
      <div class="loader-box">
        <div class="loader-16"></div>
      </div>
      <p>Consultando comprobantes repetidos...</p>
    </div>
  }

  @if (hasSearched && !isLoading && totalResults === 0 && !errorMessage) {
    <div class="repeated-vouchers-modal__empty">
      No se encontraron comprobantes repetidos para ese rango.
    </div>
  }

  @if (hasSearched && !isLoading && totalResults > 0) {
    <div class="repeated-vouchers-modal__table-wrap">
      <div class="table-responsive">
        <table class="repeated-vouchers-modal__table">
          <thead>
            <tr>
              <th>Comprobante</th>
              <th>Monto total</th>
              <th>Severidad</th>
              <th class="text-end">×</th>
            </tr>
          </thead>
          <tbody>
            @for (item of paginatedRows; track $index) {
              <tr
                class="repeated-vouchers-modal__row"
                (click)="applyRowFilter(item)"
              >
                <td class="repeated-vouchers-modal__td-id">
                  {{ item.n_comprobante || 'Sin comprobante' }}
                </td>
                <td
                  class="repeated-vouchers-modal__td-amount"
                  [class.negative]="item.monto < 0"
                >
                  {{ item.monto | number: '1.2-2' }}
                </td>
                <td>
                  <div class="repeated-vouchers-modal__sev-wrap">
                    <div class="repeated-vouchers-modal__sev-track">
                      <div
                        class="repeated-vouchers-modal__sev-fill"
                        [class.high]="getSeverityClass(item) === 'high'"
                        [class.med]="getSeverityClass(item) === 'med'"
                      ></div>
                    </div>
                    <span
                      [class.high]="getSeverityClass(item) === 'high'"
                      [class.med]="getSeverityClass(item) === 'med'"
                    >
                      {{ getSeverityLabel(item) }}
                    </span>
                  </div>
                </td>
                <td class="text-end">
                  <span
                    class="repeated-vouchers-modal__count-pill"
                    [class.high]="getSeverityClass(item) === 'high'"
                    [class.med]="getSeverityClass(item) === 'med'"
                  >
                    ×{{ item.total }}
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="repeated-vouchers-modal__footer">
      <div class="repeated-vouchers-modal__footer-meta">
        Mostrando
        {{ totalResults ? (page - 1) * pageSize + 1 : 0 }}-{{
          page * pageSize > totalResults ? totalResults : page * pageSize
        }}
        de {{ totalResults }} registros
      </div>

      <div class="repeated-vouchers-modal__footer-actions">
        <div class="repeated-vouchers-modal__pagination">
          <button
            type="button"
            class="repeated-vouchers-modal__page-btn"
            [disabled]="page === 1"
            (click)="goToFirstPage()"
          >
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button
            type="button"
            class="repeated-vouchers-modal__page-btn"
            [disabled]="page === 1"
            (click)="goToPreviousPage()"
          >
            <i class="fas fa-angle-left"></i>
          </button>

          <div class="repeated-vouchers-modal__page-status">
            <span>Página</span>
            <input
              type="number"
              min="1"
              [max]="totalPages"
              class="repeated-vouchers-modal__page-input"
              [value]="page"
              (change)="onPageInputChange($any($event.target).value)"
            />
            <span>de {{ totalPages }}</span>
          </div>

          <button
            type="button"
            class="repeated-vouchers-modal__page-btn"
            [disabled]="page === totalPages"
            (click)="goToNextPage()"
          >
            <i class="fas fa-angle-right"></i>
          </button>
          <button
            type="button"
            class="repeated-vouchers-modal__page-btn"
            [disabled]="page === totalPages"
            (click)="goToLastPage()"
          >
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  }
</div>
